import React, { useEffect, useState, useRef } from 'react';
import * as XLSX from 'xlsx';
import { MwButton, MwInputText, MwSelector, MwSpinnerButton, NoDataFound } from '../ui';
import { useTranslation } from 'react-i18next';
import { useCurrent, usePost } from '../../hooks'; // تأكد من استيراد usePost من المسار الصحيح
import useFetch from '../../hooks/useFetch'; // لا يزال يُستخدم لجلب بيانات المستودعات
import MwCardWrapper from '../ui/MwCardWrapper';
import { printableDiv } from '../../utils/global';
import { FaRegFileExcel, FaPrint, FaFilePdf } from "react-icons/fa";
import handleConvertToPDF from '../../utils/handleConvertToPDF';
import StocktakingsReportsList from './OsStocktakingsReportList';

const Stocktakings_report_Com = () => {
  const divPrintRef = useRef();
  const [t] = useTranslation('global');
  const { currentTenantId, currentCompanyId, currentBranchId, currentLangId } = useCurrent();

  const today = new Date();
  const firstDay = new Date(today.getFullYear(), today.getMonth(), 1).toLocaleDateString('en-CA');
  const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0).toLocaleDateString('en-CA');

  const [formStates, setFormStates] = useState({
    startDate: firstDay,
    endDate: lastDay,
  });

  const [fromWarehouse, setFromWarehouse] = useState(null);
  const [warehouses, setWarehouses] = useState([]);
  const [isPrintMode, setIsPrintMode] = useState(false);

  // جلب بيانات المستودعات باستخدام useFetch كما هو موجود مسبقاً
  const warehousesUrl = `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/warehouses/${currentTenantId}/${currentCompanyId}/${currentBranchId}`;
  const { data: warehousesData } = useFetch(warehousesUrl);

  // استخدام usePost لعمل طلب الفلترة عبر POST
  const { data: filterDataResult, loading: filterLoading, postData } = usePost();

  useEffect(() => {
    if (warehousesData && warehousesData.data) {
      const formattedWarehouses = warehousesData.data.map(warehouse => ({
        _id: warehouse.id,
        label: warehouse.name_ar || warehouse.name,
        name_ar: warehouse.name_ar,
        name: warehouse.name,
      }));
      setWarehouses(formattedWarehouses);
    }
  }, [warehousesData]);

  const submitHandler = (e) => {
    e.preventDefault();
    const url = `${process.env.REACT_APP_INVENTORY_API_SERVER_BASE_URL}/stocktaking/filter`;
    const payload = {
      start_date: formStates.startDate,
      end_date: formStates.endDate,
      warehouse_id: fromWarehouse,
      tenant_id: currentTenantId,
      company_id: currentCompanyId,
      branch_id: currentBranchId
    };
    // const payload = {
    //   start_date: "10-10-2024",
    //   end_date:  "10-10-2026",
    //   warehouse_id: 1,
    //   tenant_id:  "tenant_id",
    //   company_id:  "company_id",
    //   branch_id:  "branch_id"
    // };
    console.log("payload" , payload)
    postData(url, payload);
  };

  useEffect(() => {
    if (filterDataResult?.data) {
      console.log('filterDataResult', filterDataResult.data);
    } else {
      console.log('No data received or data is null');
    }
  }, [filterDataResult]);

  const printHandler = () => {
    setIsPrintMode(true);
    setTimeout(() => {
      printableDiv(divPrintRef, currentLangId);
      setTimeout(() => {
        setIsPrintMode(false);
      }, 1000);
    }, 100);
  };

  const pdfHandler = () => {
    setIsPrintMode(true);
    setTimeout(() => {
      handleConvertToPDF({
        lang: 'ar',
        elementId: 'printableDiv',
        fileName: `تقرير_مستودع.pdf`
      });
      setTimeout(() => {
        setIsPrintMode(false);
      }, 1000);
    }, 100);
  };

  const exportExcel = () => {
    if (filterDataResult?.data && filterDataResult.data.length > 0) {
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(filterDataResult.data);
      XLSX.utils.book_append_sheet(wb, ws, t("Stocktakings.Inventory_Reports"));
      XLSX.writeFile(wb, `${t("Stocktakings.Inventory_Reports")}.xlsx`);
    }
  };

  return (
    <div className='text-[#251658] h-[calc(100vh-50px)] custom-scrollbar'>
      <div id='header'>
        <p className='pb-3 text-sm'>{t("Stocktakings.Inventory_Reports")}</p>
      </div>

      <MwCardWrapper>
        <form onSubmit={submitHandler} className='flex flex-col gap-5 p-5'>
          <div className="grid grid-cols-3 gap-5">
            <div className="w-full">
              <label className="block text-start text-[#251658] mb-2 text-xs">
                {t("reports.Date_From")}
              </label>
              <div className="flex items-center">
                <MwInputText
                  inputType='date'
                  className="flex-grow"
                  value={formStates.startDate}
                  onChange={(e) => {
                    setFormStates({ ...formStates, startDate: e.target.value });
                  }}
                />
              </div>
            </div>

            <div className="w-full">
              <label className="block text-start text-[#251658] mb-2 text-xs">
                {t("reports.Date_To")}
              </label>
              <div className="flex items-center">
                <MwInputText
                  inputType='date'
                  className="flex-grow"
                  value={formStates.endDate}
                  onChange={(e) => {
                    setFormStates({ ...formStates, endDate: e.target.value });
                  }}
                />
              </div>
            </div>

            <div className="w-full">
              <label className="block text-start text-[#251658] mb-2 text-xs">
                {t("reports.Choose_Warehouse")}
              </label>
              <MwSelector
                withSearch={false}
                withLabel={false}
                label=""
                _data={warehouses}
                dataType="labelValue"
                initalValue={t("reports.Choose_Warehouse")}
                selectedItem={fromWarehouse ? warehouses?.find(w => w._id === fromWarehouse) : null}
                setSelectedItem={(item) => {
                  setFromWarehouse(item._id);
                }}
                className="w-full text-center"
                onClickNew={() => console.log('Add new warehouse')}
              />
            </div>
          </div>

          <div className='pt-3 flex justify-end'>
            {!filterLoading ? (
              <MwButton
                type='saveBtn'
                disabled={!formStates.startDate || !formStates.endDate || !fromWarehouse}
              >
                {t("reports.Prepare_Report")}
              </MwButton>
            ) : (
              <MwSpinnerButton />
            )}
          </div>
        </form>
      </MwCardWrapper>

      {(filterLoading || filterDataResult) && (
        <MwCardWrapper id='Result'>
          {filterDataResult?.data ? (
            filterDataResult.data.length > 0 ? (
              <div className='w-full'>
                <div className='flex justify-between'>
                  <div className='px-2 text-[#251658]'></div>
                  <div className='p-3 text-[#251658]'>
                    <ul className='flex gap-1'>
                      <li
                        style={{ cursor: "pointer" }}
                        onClick={exportExcel}
                        className='px-2 py-1 flex items-center gap-1 bg-white border border-gray-200 hover:border-[#251658] hover:font-bold'
                      >
                        <FaRegFileExcel />
                        <span className='text-sm text-[#251658]'>{t("reports.Export_Excel")}</span>
                      </li>
                      <li
                        style={{ cursor: "pointer" }}
                        onClick={pdfHandler}
                        className='px-2 py-1 flex items-center gap-1 bg-white border border-gray-200 hover:border-[#251658] hover:font-bold'
                      >
                        <FaFilePdf />
                        <span className='text-sm text-[#251658]'>{t("reports.Save_as_PDF")}</span>
                      </li>
                      <li
                        style={{ cursor: "pointer" }}
                        onClick={printHandler}
                        className='px-2 py-1 flex items-center gap-1 bg-white border border-gray-200 hover:border-[#251658] hover:font-bold'
                      >
                        <FaPrint />
                        <span className='text-sm text-[#251658]'>{t("reports.Print")}</span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  id='printableDiv'
                  ref={divPrintRef}
                  className={`text-[#251658] ${
                    isPrintMode
                      ? ""
                      : filterDataResult?.data?.length > 5
                      ? "h-[calc(100vh-100px)] overflow-y-scroll custom-scrollbar"
                      : "min-h-[calc(100vh-100px)]"
                  }`}
                >
                  <div className='text-[#251658] text-center'>
                    <div className='font-bold'>{t("Stocktakings.Inventory_Report_Period")}</div>
                    <div className='font-medium'>
                      <span>{t("reports.From")} {formStates.startDate}</span>
                      <span className="mx-2">{t("reports.To")} {formStates.endDate}</span>
                    </div>
                  </div>
                  {filterDataResult.data && <StocktakingsReportsList data={filterDataResult.data || []} />}
                </div>
              </div>
            ) : (
              <NoDataFound msg={t("reports.No_Results")} />
            )
          ) : (
            <NoDataFound msg={t("reports.No_Results")} />
          )}
        </MwCardWrapper>
      )}
    </div>
  );
};

export default Stocktakings_report_Com;
